import dog from "../assets/dog.png";
import logo from "../assets/logo.png";

function MainBlock() {
    return ( 
        <>
            <section className="main-block" id="main">
                <div className="container">
                    <nav>
                        <div className="logo">
                            <img src={logo} alt="" />
                        </div>

                        <div className="links">
                            <a href="#main" className="link-header">MAIN</a>
                            <a href="#who-we-are" className="link-header">WHO WE ARE</a>
                            <a href="#stories" className="link-header">STORIES</a>
                            <a href="#contacts" className="link-header">CONTACT US</a>
                        </div>
                        
                        <a href="https://animalfoundation.com/donate" target="_blank">
                            <button className="donate-button">
                                DONATE
                            </button>
                        </a>

                    </nav>

                    <div className="main-block-row row">
                        <div className="col-12 col-md-12 col-lg-6">
                        
                            <h1 className="main-heading">Every Pet Deserves a Happy Home</h1>
                        
                            <p className="description">
                                Wolfpack Animals Foundation is dedicated to protecting and improving the lives of dogs and cats by preventing abandonment, neglect, and abuse. Through education, advocacy, and access to veterinary care, we work to create a safer, more compassionate world for animals in need.
                            </p>

                            <a href="https://animalfoundation.com/donate" target="_blank">
                                <button className="donate-button">
                                    DONATE
                                </button>
                            </a>

                        </div>
                        <div className="col-12 col-md-12 col-lg-6">
                            <div className="main-block-image">
                                <img src={dog} alt="DOG" className="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
     );
}

export default MainBlock;